import { render, staticRenderFns } from "./SingInputAndTable.vue?vue&type=template&id=1f8734e2&scoped=true&"
import script from "./SingInputAndTable.vue?vue&type=script&lang=js&"
export * from "./SingInputAndTable.vue?vue&type=script&lang=js&"
import style0 from "./SingInputAndTable.vue?vue&type=style&index=0&id=1f8734e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8734e2",
  null
  
)

export default component.exports